'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsHalfOp = supportsHalfOp;
exports.isAChannelModeAdmin = isAChannelModeAdmin;
exports.isQChannelModeOwner = isQChannelModeOwner;
exports.extbanAccount = extbanAccount;
function supportsHalfOp(network) {
    var ircdType = network.ircd.toLowerCase();
    var notSupported = ['ircd-seven', 'charybdis'];

    for (var i = 0; i < notSupported.length; i++) {
        if (ircdType.indexOf(notSupported[i]) > -1) {
            return false;
        }
    }

    return true;
}

function isAChannelModeAdmin(network) {
    var ircdType = network.ircd.toLowerCase();
    var notAdmin = ['ircd-seven', 'charybdis'];

    for (var i = 0; i < notAdmin.length; i++) {
        if (ircdType.indexOf(notAdmin[i]) > -1) {
            return false;
        }
    }

    return true;
}

function isQChannelModeOwner(network) {
    var ircdType = network.ircd.toLowerCase();
    var notOwner = ['ircd-seven', 'charybdis'];

    for (var i = 0; i < notOwner.length; i++) {
        if (ircdType.indexOf(notOwner[i]) > -1) {
            return false;
        }
    }

    return true;
}

function extbanAccount(network) {
    var ircdType = network.ircd.toLowerCase();

    var extban = network.ircClient.network.supports('EXTBAN') || '';
    if (!extban) {
        return '';
    }

    var prefix = extban.split(',')[0];
    var type = 'a';

    if (ircdType.indexOf('inspircd') > -1) {
        type = 'R';
    }

    return prefix + type;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["helpers"]) window._kiwi_exports["helpers"] = {};
window._kiwi_exports["helpers"]["IrcdDiffs"]
window._kiwi_exports.helpers.IrcdDiffs = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/helpers/IrcdDiffs.js
// module id = 1gJW
// module chunks = 1